<div class="modal-header">
  <button
    type="button"
    class="close pull-right align-middle"
    aria-label="Close"
    id="giftCardCustomizationHideButton"
    data-testid="gift-card-customization-close-button"
    (click)="hide(false, false)"
  >
    <span aria-hidden="true">×</span>
  </button>
  <div>
    <h3 class="modal-title w-100 pull-left align-left">
      <i class="fa fa-gift"></i>
      Customize your gift certificate!
    </h3>
  </div>
</div>
<div class="modal-body">
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        You're one step closer to giving an awesome gift to your friend or loved one! Just fill in the form below to continue.
      </div>
    </div>
    <div class="row p-2">
      <form id="giftCardCustomizationForm" [formGroup]="formGroup" (ngSubmit)="submit()">
        <div class="form-row">
          <div class="form-group col-md-6" *ngIf="isDigitalGiftCard">
            <label for="recipientName">Name of Recipient</label>
            <input
              type="text"
              [ngClass]="{ 'form-control': true, 'is-invalid': formGroup.controls['recipientName'].invalid }"
              id="recipientName"
              formControlName="recipientName"
              placeholder="Name"
              data-testid="gift-card-recipient-name-input"
            />
            <small *ngIf="formGroup.controls['recipientName'].invalid" class="text-danger"
              >Must be under 50 characters.</small
            >
          </div>
          <div class="form-group col-md-6" *ngIf="isDigitalGiftCard">
            <label for="recipientEmail">Recipient's Email Address</label>
            <input
              type="email"
              [ngClass]="{ 'form-control': true, 'is-invalid': formGroup.controls['recipientEmail'].invalid }"
              id="recipientEmail"
              formControlName="recipientEmail"
              placeholder="Email"
              data-testid="gift-card-recipient-email-input"
            />
            <small *ngIf="formGroup.controls['recipientEmail'].invalid" class="text-danger"
              >Must be a valid email address.</small
            >
          </div>
          <div class="form-group col-md-6">
            <label for="giftCardValue">Select Gift Card Value</label>
            <select class="form-control" formControlName="giftCardValue" id="giftCardValue"
                    data-testid="gift-card-value-input">
              <option *ngFor="let value of priceValues" [ngValue]="value">{{value}}</option>
              <option [ngValue]="0">Custom Amount</option>
            </select>
          </div>
          <div class="form-group col-md-6" *ngIf="showCustomValueField">
            <label for="customValue">Enter Custom Value</label>
            <input
              type="number"
              [ngClass]="{ 'form-control': true, 'is-invalid': formGroup.controls['customValue'].invalid }"
              id="customValue"
              formControlName="customValue"
              placeholder="Custom Value"
              data-testid="gift-card-custom-value-input"
            />
            <small *ngIf="formGroup.controls['customValue'].invalid" class="text-danger"
              >Must be a whole number between 25 and 1000.</small
            >
          </div>
        </div>
        <div class="form-group" *ngIf="isDigitalGiftCard">
          <label for="customMessage">Message for Recipient</label>
          <textarea
            [ngClass]="{ 'form-control': true, 'is-invalid': formGroup.controls['customMessage'].invalid }"
            id="customMessage"
            formControlName="customMessage"
            rows="5"
            placeholder="If you don't supply a message here, a generic one will be used."
            data-testid="gift-card-custom-message-input"
          ></textarea>
          <small *ngIf="formGroup.controls['customMessage'].invalid" class="text-danger"
            >Must be under 250 characters.</small
          >
        </div>
        <button type="submit" class="btn btn-success pull-right" [disabled]="isSubmitDisabled"
                data-testid="gift-card-submit-button">
          <i class="fa fa-shopping-cart icon-on-left"></i>
          <span *ngIf="!isUpdate">Add To Cart</span>
          <span *ngIf="isUpdate">Update</span>
        </button>
      </form>
    </div>
  </div>
</div>
